import React from "react";

const JindalVideo = () => {
  return (
    <div className="container">
      <div class="row">
      <div class="col-12">
        <div class="contentbox">
        <iframe
        width="100%"
        height="500"
        src="https://www.youtube.com/embed/UvGwIFVUK7M"
        title="Jindal Video"
        frameBorder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen>
        </iframe>
        </div>
      
      </div>
      </div>
    </div>
  );
};

export default JindalVideo;
